import { Action } from '@ngrx/store';

export const CMS_COMPONENTS_CLEAR_STATE = '[Cms] Components clear state';

export class CmsComponentsClearState implements Action {
  readonly type = CMS_COMPONENTS_CLEAR_STATE;
}

export type CmsActions = CmsComponentsClearState;
